<template>
  <div v-if="visible" class="debug-send-buttons">
    <div class="debug-buttons-title">调试快捷发送</div>
    <div class="debug-buttons-row">
      <button class="debug-btn" @click="$emit('send', '请帮我讲解英语语法')">英语语法</button>
      <button class="debug-btn" @click="$emit('send', '请帮我讲解英语时态')">英语时态</button>
      <button class="debug-btn" @click="$emit('send', '请帮我讲解英语习语')">英语习语</button>
      <button class="debug-btn" @click="$emit('send', '我想了解颜色')">颜色</button>
      <button class="debug-btn" @click="$emit('send', 'i like red color')">红色</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['send']);
</script>

<style scoped lang="scss">
.debug-send-buttons {
  position: fixed;
  top: 50px;
  right: 10px;
  z-index: 999;
  padding: 8px;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 8px;
  backdrop-filter: blur(4px);

  .debug-buttons-title {
    font-size: 12px;
    color: #999;
    margin-bottom: 6px;
  }

  .debug-buttons-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .debug-btn {
    padding: 8px 12px;
    font-size: 13px;
    color: #fff;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;

    &:active {
      opacity: 0.85;
    }
  }
}
</style>
